import React from "react";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import Select from "./common/select";
import Checkbox from "./common/checkbox";
import http from "../services/http";

const ParameterSubscribe = ({ show, handleChange, handleHide, data, info }) => {
  const subscriptionTypes = [
    { id: 1, name: "On Value Entered" },
    { id: 2, name: "Data Outside Check Limits" },
    { id: 3, name: "Data Outside Absolute Limits" },
  ];

  const sites = [
    { id: "BA", name: "Bardney" },  
    { id: "BU", name: "Bury" },
    { id: "CA", name: "Cantley" },
    { id: "NE", name: "Newark" },
    { id: "WI", name: "Wissington" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await http.post("/parameter-subscribe", data);
      toast.success(`Subscribed to ${data.code}`);
    } catch (ex) {
      if (ex.response && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    handleHide();
  };

  return (
    <Modal show={show} onHide={handleHide}>
      <Modal.Header closeButton className="bg-success text-white">
        <Modal.Title>Subscribe to {data.code}</Modal.Title>
      </Modal.Header>
      <form>
        <Modal.Body>
          <div className="form-row">
            <div className="col">
              <Select
                name="type"
                label="Subscription Type"
                placeholder="type"
                value={data.type}
                options={subscriptionTypes}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col">
              <Select
                name="site"
                label="Site"
                placeholder="site"
                value={data.site}
                options={sites}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col">
              <Checkbox
                name="email"
                label="Email"
                checked={data.email}
                onChange={handleChange}
              />
            </div>
            <div className="col">
              <Checkbox
                name="push"
                label="Push Notification"
                checked={data.push}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col">
              <p>
                <em className="text-warning">
                  Subscriptions will only work on typed parameter values
                </em>
                <br />
                <em>By default all subscriptions will create a notification</em>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col">Limits</div>
          </div>
          {info && (
            <div className="row">
              <div className="col">
                Absolute: {info.LOWER_ABS_LIMIT ? info.LOWER_ABS_LIMIT : "None"}{" "}
                - {info.UPPER_ABS_LIMIT ? info.UPPER_ABS_LIMIT : "None"}
              </div>
              <div className="col">
                Check: {info.LOWER_CHK_LIMIT ? info.LOWER_CHK_LIMIT : "None"} -{" "}
                {info.UPPER_CHK_LIMIT ? info.UPPER_CHK_LIMIT : "None"}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={handleSubmit}>
            Subscribe
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default ParameterSubscribe;
